import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function BibleStudyDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/bible-studies/${slug}`).then((r) => setS(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err)
    return (
      <div className="container-reading py-24 text-center">
        <h1 className="heading-2">Study not found.</h1>
        <Link to="/bible-studies" className="mt-6 btn-primary inline-flex">All Studies</Link>
      </div>
    );
  if (!s) return <div className="container-reading py-24 text-ink-muted">Loading…</div>;

  return (
    <article>
      <header className="bg-subtle border-b border-border py-16">
        <div className="container-reading">
          <Link to="/bible-studies" className="inline-flex items-center gap-1 text-sm text-ink-muted hover:text-forest">
            <ChevronLeft className="h-4 w-4" /> Bible Studies
          </Link>
          <p className="eyebrow mt-6 text-forest">
            {s.testament === "old" ? "Old Testament" : "New Testament"} · {s.study_type}
          </p>
          <h1 className="heading-1 mt-3">{s.title}</h1>
          <p className="lead mt-6">{s.summary}</p>
          <div className="mt-6 text-sm text-ink-muted">
            By {s.author_name} · Reviewed by {s.reviewer_name || "Elder Team"}
          </div>
        </div>
      </header>

      <div className="container-reading py-16 prose-editorial">
        {s.key_passages?.length > 0 && (
          <div className="mb-8 border-l-2 border-gold pl-6">
            <p className="eyebrow">Key Passages</p>
            <p className="mt-2 text-ink">{s.key_passages.join(" · ")}</p>
          </div>
        )}
        <div dangerouslySetInnerHTML={{ __html: s.body }} />
        {s.application && (
          <div className="my-10 border-l-2 border-forest pl-6">
            <p className="eyebrow text-forest">Application</p>
            <p className="mt-2 body-copy">{s.application}</p>
          </div>
        )}
        {s.reflection_questions?.length > 0 && (
          <div className="my-10 paper-card p-8 bg-subtle">
            <p className="eyebrow">Reflection</p>
            <ol className="mt-4 space-y-2 list-decimal pl-6 text-ink-soft">
              {s.reflection_questions.map((q, i) => (
                <li key={i}>{q}</li>
              ))}
            </ol>
          </div>
        )}
      </div>
    </article>
  );
}
